export const KEYWORD_RANK_PRODUCT_KEY = "keyword_rank";
export const PAGE_OPTIMIZATION_PRODUCT_KEY = "page_optimization";
export const AI_META_TITLE_PRODUCT_KEY = "ai_meta_title";
export const AI_META_DESCRIPTION_PRODUCT_KEY = "ai_meta_description";
export const AI_SCHEMA_PRODUCT_KEY = "ai_page_schema";
